import { OwnerContractDetailsContext } from '@/contexts'
import { useContext } from 'react'

export const useOwnerContractDetailsContext = () => {
  const context = useContext(OwnerContractDetailsContext)

  if (!context) {
    throw new Error('useOwnerContractDetailsContext must be used within OwnerContractDetailsContextProvider')
  }

  return context
}